import { LoginPage } from 'containers/Login/pages';
import { Errors } from 'modules/Api/Errors';
import reducer from 'modules/Api/reducer';
import saga from 'modules/Api/saga';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactDOM } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import '../../base.scss';
import { BaseComponent } from '../../components/BaseComponent';
import { Loader } from '../../components/Loader';
import { ACCOUNT_DOMAIN } from '../../modules/Account/constants';
import { AccountPage } from '../../modules/Account/pages';
import { accountReducer } from '../../modules/Account/reducer';
import { ACTIONS_DOMAIN } from '../../modules/Actions/constants';
import { actionReducer } from '../../modules/Actions/reducer';
import { ADDRESSES_DOMAIN } from '../../modules/Address/constants';
import { addressReducer } from '../../modules/Address/reducer';
import { checkSession, getConfig } from '../../modules/Api/actions';
import { selectIsLoggedIn, selectMe, selectUserRights } from '../../modules/Api/selectors';
import { COMPANIES_DOMAIN } from '../../modules/Companies/constants';
import { CompaniesPage } from '../../modules/Companies/pages';
import { companyReducer } from '../../modules/Companies/reducer';
import { companiesSaga } from '../../modules/Companies/saga';
import { ContentsPage } from '../../modules/Content/page';
import { INVOICES_DOMAIN } from '../../modules/Invoices/constants';
import { InvoicesPage } from '../../modules/Invoices/pages';
import { invoiceReducer } from '../../modules/Invoices/reducer';
import { KANBANBOARDS_DOMAIN } from '../../modules/KanbanBoards/constants';
import { KanbanBoardsPage } from '../../modules/KanbanBoards/pages';
import { EmailHistoryBoardPage } from '../../modules/emailHistory/pages';
import { kanbanBoardReducer } from '../../modules/KanbanBoards/reducer';
import { kanbanBoardSaga } from '../../modules/KanbanBoards/saga';
import { ORB_DOMAIN } from '../../modules/ORB/constants';
import { ORBPage } from '../../modules/ORB/pages';
import { ORBReducer } from '../../modules/ORB/reducer';
import { ToolsPage } from '../../modules/Tools/pages';
import { USERS_DOMAIN } from '../../modules/Users/constants';
import { UsersPage } from '../../modules/Users/pages';
import { userReducer } from '../../modules/Users/reducer';
import { usersSaga } from '../../modules/Users/saga';
import { getMMT } from '../../modules/Vehicles/actions';
import { VEHICLES_DOMAIN } from '../../modules/Vehicles/constants';
import { VehiclesPage } from '../../modules/Vehicles/pages';
import { vehicleReducer } from '../../modules/Vehicles/reducer';
import { vehiclesSaga } from '../../modules/Vehicles/saga';
import { TRANSPORT_ORDER_DOMAIN } from '../../modules/TransportOrders/constants';
import { transportOrderReducer } from '../../modules/TransportOrders/reducer';
import { transportOrderSaga } from '../../modules/TransportOrders/saga';
import { TRANSPORTER_DOMAIN } from '../../modules/Transporters/constants';
import { transporterReducer } from '../../modules/Transporters/reducer';
import { transporterSaga } from '../../modules/Transporters/saga';
import { Home } from '../Home';
import { Logout } from '../Login/pages/logout';
import { Authorized } from './Authorized';
import { APP_DOMAIN, CHECK_APP_VERSION, UI_WINDOW_RESIZE } from './constants';
import { Left } from './layout/containers/NavBar/NavBar';
import { appReducer } from './reducer';
import { appSagas } from './saga';
import { selectUI } from './selectors';
import { Top } from './layout/containers/Header/Header';
import { invoicesSaga } from '../../modules/Invoices/saga';
import { EMAILS_DOMAIN } from '../../modules/emailHistory/constants';
import { emailsHistoryReducer } from '../../modules/emailHistory/reducer';
import { emailHistorySaga } from '../../modules/emailHistory/saga';
import { selectScrollPosition } from '../../modules/Actions/selectors';
import { setScrollPosition } from '../../modules/Actions/actions';
import { HEXON_DOMAIN } from '../../modules/Hexon/constants';
import { HexonReducer } from '../../modules/Hexon/reducer';
import { HexonPage } from '../../modules/Hexon/pages';
import { ProductsPage } from '../../modules/products/pages';
import { PRODUCTS_DOMAIN } from '../../modules/products/constants';
import { productsSaga } from '../../modules/products/saga';
import { productsReducer } from '../../modules/products/reducer';
import { SilverdatPage } from '../../modules/Silverdat/pages';
import { WORKFLOWS_DOMAIN } from '../../modules/Workflows/constants';
import { workflowsReducer } from '../../modules/Workflows/reducer';
import { WorkflowsPage } from '../../modules/Workflows/pages';
import { workflowsSaga } from '../../modules/Workflows/saga';
import { toolsReducer } from '../../modules/Tools/reducer';
import { TOOLS_DOMAIN } from '../../modules/Tools/constants';
import { WebloginPage } from '../../modules/Weblogin/pages';
import { WEBLOGIN_DOMAIN } from '../../modules/Weblogin/constants';
import { webloginReducer } from '../../modules/Weblogin/reducer';
import { AZURE_DOMAIN } from '../../modules/Azure/constants';
import { azureReducer } from '../../modules/Azure/reducer';
import { withMsal } from '@azure/msal-react';
import { WebsiteUsersPage } from '../../modules/Users/pages/website';
import { TransportOrdersPage } from '../../modules/TransportOrders/pages';
import { TransportersPage } from '../../modules/Transporters/pages';
import { StatsPage } from '../../modules/Stats/pages';
import { STATS_DOMAIN } from '../../modules/Stats/constants';
import { statsReducer } from '../../modules/Stats/reducer';

export const Body = styled.div`
  position: ${props => (props.innerWidth <= 768 ? 'fixed' : '')};
  top: ${props => (props.innerWidth <= 768 ? '0px' : '')};
  max-width: 100vw;
  width: 100%;
  display: flex;
  overflow: hidden;
`;

const BodyContent = styled.div`
  min-height: 1200px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh);
  max-height: calc(100vh);
  width: 100%;
`;

export const Page = styled.div`
  position: relative;
  padding: ${props => (props.innerWidth <= 768 ? '' : '12px')};

  min-width: ${props => (props.fullWidth ? '100vw' : 'calc(100vw - 300px) ')};

  height: calc(100vh);
  max-height: calc(100vh);
  overflow-x: auto;

  @media (max-width: 768px) {
    height: calc(92vh);
    max-height: calc(92vh);
  }
`;

const OVERVIEW_PAGES = ['/companies', '/vehicles', '/invoices', '/users'];

const MainContent = styled.div`
  padding-top: ${props => (props.innerWidth <= 768 ? '' : '12px')};
  padding: ${props => (props.innerWidth <= 768 ? '0 12px' : '0px 12px 12px 12px')};
  min-height: 75vh;
  margin: auto;
  // padding-bottom: 160px;
`;

/* eslint-disable react/prefer-stateless-function */
export class AppComp extends BaseComponent {
  constructor(props) {
    super(props, {});
    this.myRef = React.createRef();
  }

  componentDidMount() {
    window.onresize = this.props.resize;
    this.props.checkAppVersion();
    this.checkVersionInterval = setInterval(this.props.checkAppVersion, 30000);
    this.props.get();

    if (this.props.history.location.pathname.indexOf('login/one-time') > -1) {
      this.props.disableSession();
    } else if (this.props.history.location.pathname.indexOf('logout') > -1) {
      // don't check session if we are on the logout page (prevents a race condition where we login at the start of the logout page...)
    } else {
      this.props.checkSession();
    }
  }

  componentDidUpdate(prevProps) {
    try {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        if (
          !OVERVIEW_PAGES.includes(prevProps.location.pathname) &&
          OVERVIEW_PAGES.includes(this.props.location.pathname) &&
          !!this.props.savedScroll
        ) {
          let el = this.props.savedScroll ? document.querySelector(this.props.savedScroll) : null;
          if (el) {
            el.scrollIntoView();
          } else {
            this.myRef?.current.scrollIntoView({ top: 0 });
          }
        } else {
          this.myRef?.current.scrollIntoView({ top: 0 });
        }
      }
    } catch (error) {}
  }

  componentWillUnmount() {
    // Clear the interval when the component unmounts to avoid memory leaks
    clearInterval(this.checkVersionInterval);
  }

  renderBody() {
    // if (this.props.msalContext.inProgress === 'handleRedirect') {
    //   return <Loader onCard />;
    // }

    if (this.props.works) {
      return <Loader onCard />;
    }

    // logout page
    if (this.props.history.location.pathname.indexOf('/logout') > -1) {
      return <Logout />;
    }

    if (!this.props.isLoggedIn) {
      // login required past this point

      return (
        <Switch>
          {/* <Route path="(.*)/login(.*)" component={LoginPage} /> */}
          <Route component={LoginPage} />
        </Switch>
      );
    }
    if (!this.props.me) {
      // requires tags past this point
      return <Loader small />;
    }

    if (this.props.me.weblogin) {
      return <WebloginPage />;
    }
    // welcome! :)
    // code redeem active after register

    return (
      <BodyContent ref={this.myRef} id="scrollContainer">
        <Authorized>
          <Switch>
            <Route path="(.*)/login(.*)" component={LoginPage} />
            <Route path="(.*)/me(.*)" component={AccountPage} />
            <Route path="(.*)/home(.*)" component={Home} />
            <Route path="(.*)/boards(.*)" component={KanbanBoardsPage} />
            <Route path="(.*)/email_history" component={EmailHistoryBoardPage} />
            <Route path="(.*)/vehicles(.*)" component={VehiclesPage} />
            <Route path="(.*)/users(.*)" component={UsersPage} />
            <Route path="(.*)/website-users(.*)" component={WebsiteUsersPage} />
            <Route path="(.*)/companies(.*)" component={CompaniesPage} />
            <Route path="(.*)/invoices(.*)" component={InvoicesPage} />
            <Route path="(.*)/tools(.*)" component={ToolsPage} />
            <Route path="(.*)/statistics(.*)" component={StatsPage} />
            <Route path="(.*)/ORB(.*)" component={ORBPage} />
            <Route path="(.*)/hxn" component={HexonPage} />
            <Route path="(.*)/products(.*)" component={ProductsPage} />
            <Route path="(.*)/silverdat(.*)" component={SilverdatPage} />
            <Route path="(.*)/workflows(.*)" component={WorkflowsPage} />
            <Route path="(.*)/transport-orders(.*)" component={TransportOrdersPage} />
            <Route path="(.*)/transporters(.*)" component={TransportersPage} />
            <Route render={() => <Redirect to="/vehicles" />} />
          </Switch>
        </Authorized>
      </BodyContent>
    );
  }

  renderUnAuth() {
    return <LoginPage />;
  }

  renderContent() {
    return (
      <Route path="(.*)/content/:content" render={component => <ContentsPage content={component.match.params.content} />} />
    );
  }

  render() {
    return (
      <Body innerWidth={window.innerWidth}>
        {window.innerWidth > 1440 && <Left />}
        <Content>
          <Top />
          <Errors />

          <Page fullWidth={!this.props.isLoggedIn} innerWidth={window.innerWidth}>
            <MainContent innerWidth={window.innerWidth}>{this.renderBody()}</MainContent>
          </Page>
        </Content>
      </Body>
    );
  }
}

AppComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    isLoggedIn: selectIsLoggedIn(),
    rights: selectUserRights(),
    me: selectMe(),
    UI: selectUI(),
    savedScroll: selectScrollPosition(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get() {
      dispatch(getConfig());
      dispatch(getMMT());
    },
    disableSession() {},
    checkSession() {
      dispatch(checkSession());
    },
    resize(evt) {
      dispatch({ type: UI_WINDOW_RESIZE });
    },
    setScroll(pos) {
      dispatch(setScrollPosition(pos));
    },
    checkAppVersion() {
      dispatch({ type: CHECK_APP_VERSION });
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const App = compose(
  injectReducer({ key: APP_DOMAIN, reducer: appReducer }),
  injectSaga({ key: APP_DOMAIN, saga: appSagas }),

  injectReducer({ key: 'api', reducer }),
  injectSaga({ key: 'api', saga }),

  injectReducer({ key: ACCOUNT_DOMAIN, reducer: accountReducer }),

  injectReducer({ key: KANBANBOARDS_DOMAIN, reducer: kanbanBoardReducer }),
  injectSaga({ key: KANBANBOARDS_DOMAIN, saga: kanbanBoardSaga }),
  injectReducer({ key: VEHICLES_DOMAIN, reducer: vehicleReducer }),
  injectSaga({ key: VEHICLES_DOMAIN, saga: vehiclesSaga }),

  injectReducer({ key: USERS_DOMAIN, reducer: userReducer }),
  injectSaga({ key: USERS_DOMAIN, saga: usersSaga }),

  injectReducer({ key: ACTIONS_DOMAIN, reducer: actionReducer }),

  injectReducer({ key: COMPANIES_DOMAIN, reducer: companyReducer }),
  injectSaga({ key: COMPANIES_DOMAIN, saga: companiesSaga }),

  injectReducer({ key: INVOICES_DOMAIN, reducer: invoiceReducer }),
  injectSaga({ key: INVOICES_DOMAIN, saga: invoicesSaga }),

  injectReducer({ key: PRODUCTS_DOMAIN, reducer: productsReducer }),
  injectSaga({ key: PRODUCTS_DOMAIN, saga: productsSaga }),

  injectReducer({ key: ADDRESSES_DOMAIN, reducer: addressReducer }),

  injectReducer({ key: ORB_DOMAIN, reducer: ORBReducer }),
  injectReducer({ key: HEXON_DOMAIN, reducer: HexonReducer }),

  injectReducer({ key: EMAILS_DOMAIN, reducer: emailsHistoryReducer }),
  injectSaga({ key: EMAILS_DOMAIN, saga: emailHistorySaga }),

  injectReducer({ key: TOOLS_DOMAIN, reducer: toolsReducer }),

  injectReducer({ key: STATS_DOMAIN, reducer: statsReducer }),

  injectReducer({ key: WORKFLOWS_DOMAIN, reducer: workflowsReducer }),
  injectSaga({ key: WORKFLOWS_DOMAIN, saga: workflowsSaga }),

  injectReducer({ key: TRANSPORT_ORDER_DOMAIN, reducer: transportOrderReducer }),
  injectSaga({ key: TRANSPORT_ORDER_DOMAIN, saga: transportOrderSaga }),

  injectReducer({ key: TRANSPORTER_DOMAIN, reducer: transporterReducer }),
  injectSaga({ key: TRANSPORTER_DOMAIN, saga: transporterSaga }),
  //weblogin

  injectReducer({ key: WEBLOGIN_DOMAIN, reducer: webloginReducer }),

  withConnect,
  withRouter,
  withMsal,
)(AppComp);
